export default {"src":"/_next/static/media/wings.2b901979.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};